export default __webpack_public_path__ + "static/italy-me-b92e0bcc55bf3e1bd69083bff1c6181d.jpg";